import React from 'react';
import { Box, Grid } from '@mui/material';
import SubCard from 'src/components/cards/SubCard';
import ServiceReportCard from 'src/views/ServicePerformanceCharts/ServiceReportCard';
import ServiceComplaint from 'src/views/ServicePerformanceCharts/ServiceComplaint';
import ServiceNps from 'src/views/ServicePerformanceCharts/ServiceNps';
import ServiceAverageTime from 'src/views/ServicePerformanceCharts/ServiceAverageTime';
import ServiceRejectRate from 'src/views/ServicePerformanceCharts/ServiceRejectRate';
import ServiceAppointmentConformity from 'src/views/ServicePerformanceCharts/ServiceAppointmentConformity';
import ServiceExtraWarrantyAndTurnover from 'src/views/ServicePerformanceCharts/ServiceExtraWarrantyAndTurnover';
import ServiceComplementaryProductAndTurnover from 'src/views/ServicePerformanceCharts/ServiceComplementaryProductAndTurnover';

const ServicePerformance = ({ ServiceShopId, ServiceShopFullName, TopServiceShopCode, EmployeeRole }) => {
    return (
        <SubCard title={ServiceShopFullName}>
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="EK GARANTİ" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceExtraWarrantyAndTurnover ServiceShopId={ServiceShopId} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="TAMAMLAYICI ÜRÜN" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceComplementaryProductAndTurnover ServiceShopId={ServiceShopId} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Karne Sonuçları" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceReportCard
                                    ServiceShopId={ServiceShopId}
                                    TopServiceShopCode={TopServiceShopCode}
                                />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Şikayet" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceComplaint ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="NPS" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceNps ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 6
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Randevuya Uyum" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceAppointmentConformity ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Ortalama Hizmet Süresi" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceAverageTime ServiceShopId={ServiceShopId}
                                    EmployeeRole={EmployeeRole} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12
                    }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <SubCard title="Red oranları ve nedenleri" sx={{ flexGrow: 1 }}>
                            <Box sx={{ p: 2, height: '100%' }}>
                                <ServiceRejectRate ServiceShopId={ServiceShopId} />
                            </Box>
                        </SubCard>
                    </Box>
                </Grid>
            </Grid>
        </SubCard>
    );
};



export default ServicePerformance;